/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_RailInputs */

const fr_vehicle_type_rail = /** @type {(inputs: Vehicle_Type_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train`)
};

const en_vehicle_type_rail = /** @type {(inputs: Vehicle_Type_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train`)
};

/**
* | output |
* | --- |
* | "Train" |
*
* @param {Vehicle_Type_RailInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_rail = /** @type {((inputs?: Vehicle_Type_RailInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_RailInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_rail(inputs)
	return en_vehicle_type_rail(inputs)
});